import { render, staticRenderFns } from "./ForumCategoriesPage.vue?vue&type=template&id=5a27e958&scoped=true"
import script from "./ForumCategoriesPage.vue?vue&type=script&lang=js"
export * from "./ForumCategoriesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27e958",
  null
  
)

export default component.exports